<!--Apartato de registro manual de asistentes-->
<template>
  <v-row class="mt-12 mx-6">
    <v-col cols="12">
      <v-row>
        <v-col cols="8">
          <p class="headline font-weight-bold">
            Configuración del formulario de registro
          </p>
          <p class="text-subtitle-1 font-weight-bold">

            En este y en todos los formularios, los campos de "Nombre", "Apellidos", "Email" y "Confirmar e-mail" ya
            están precargados, no es necesario que los cargues de otra vez.
            <v-btn icon color="blue" class="mb-1" @click.stop="dialogWarning = true">
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </p>

        </v-col>
        <v-col cols="4" class="d-flex justify-end align-center">          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn icon v-on="on" v-bind="attrs" @click="showTutorial = true">
                <v-icon color="grey darken-1">mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Ver tutorial de secciones</span>
          </v-tooltip>          <v-select
            v-if="tickets.items.length > 0"
            :items="tickets.items"
            v-model="tickets.selected"
            @change="handleTicketSelection"
            item-text="name"
            item-value="id"
            label="Seleccionar Ticket"
            filled
            rounded
          />
        </v-col>
      </v-row>
      <v-row
        v-if="tickets.selected && user.permissions.Event && user.permissions.Event.update"
        class="mb-2"
      >
        <v-col cols="12" class="d-flex justify-end pt-0">
          <action-button
            class="mr-2"
            outlined
            @click="addSection"
            iconLeft
            icon="mdi-table-row-plus-after"
          >
            Agregar sección
          </action-button>
          <action-button @click="addField" iconLeft icon="mdi-plus">
            Nuevo campo
          </action-button>
        </v-col>
      </v-row>
      <v-divider class="mb-6" />

      <!-- Tabs por sección -->
      <template v-if="tickets.selected">
        <v-tabs v-model="activeTab" background-color="transparent" show-arrows class="mb-1">
          <v-tab v-for="tab in tabList" :key="tab._id || 'unsectioned'">
            {{ tab.name }}
          </v-tab>
        </v-tabs>
        <v-divider class="mb-4" />
        <v-tabs-items v-model="activeTab">
          <v-tab-item v-for="tab in tabList" :key="tab._id || 'unsectioned'">

            <!-- Renombrar / eliminar sección (solo secciones reales) -->
            <v-row
              v-if="tab._id && user.permissions.Event && user.permissions.Event.update"
              align="center"
              class="mt-3 mb-4 px-1"
              no-gutters
            >
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="tab.name"
                  label="Nombre de la sección"
                  dense
                  filled
                  rounded
                  hide-details
                  @focus="tab._editing = true"
                />
              </v-col>
              <v-col cols="auto" class="ml-2">
                <v-btn
                  icon
                  small
                  color="green"
                  :loading="savingSectionId === tab._id"
                  v-if="tab._editing"
                  @click="saveSectionName(tab)"
                >
                  <v-icon small>mdi-content-save-outline</v-icon>
                </v-btn>
                <v-btn icon small color="red" @click="removeSectionAdmin(tab)">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-2">
              <v-col
                v-if="fieldsForTab(tab._id).length > 0"
                cols="12"
                class="pt-0"
              >
                <draggable
                  :list="fieldsForTab(tab._id)"
                  handle=".drag-handle"
                  :animation="200"
                  ghost-class="drag-ghost"
                  @end="e => onFieldDragEnd(e, tab._id)"
                >
                  <v-card
                    v-for="field in fieldsForTab(tab._id)"
                    :key="field._id"
                    outlined
                    rounded="lg"
                    class="mb-3"
                  >
                    <!-- HEADER -->
                    <v-list-item style="cursor:pointer" @click="toggleField(field)">
                      <v-icon class="drag-handle mr-3" color="grey lighten-1" @click.stop>mdi-drag-vertical</v-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{ field.name || 'Nuevo campo' }}</v-list-item-title>
                        <v-list-item-subtitle v-if="!isFieldOpen(field)" class="d-flex align-center flex-wrap" style="gap:4px">
                          {{ fieldTypeLabel(field.fieldType) }}
                          <v-chip v-if="field.required" x-small color="red lighten-4" text-color="red darken-2" class="ml-1">Requerido</v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-dialog v-if="!field.new && !field.edit" v-model="field.deleteDialog" width="300" @click.native.stop>
                        <template #activator="{ on, attrs }">
                          <v-btn icon x-small color="red lighten-2" v-on="on" v-bind="attrs" @click.stop :disabled="!user.permissions.Event || !user.permissions.Event.update">
                            <v-icon small>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="text-h5">Eliminar campo extra</v-card-title>
                          <v-divider />
                          <v-card-text class="text-justify my-5">{{ field.new ? "¿Seguro que no quiere guardar este campo?" : `¿Seguro de que quiere eliminar el campo "${field.name}"?` }}</v-card-text>
                          <v-divider />
                          <v-card-actions>
                            <v-spacer />
                            <v-btn color="grey" text @click="field.deleteDialog = false">Cancelar</v-btn>
                            <v-btn color="red" text @click="deleteField(field)" :disabled="!user.permissions.Event || !user.permissions.Event.update">Eliminar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <icon-action-button v-if="field.new || field.edit" tooltip="Cancelar" color="red" @click.native.stop @click="cancelAction(field)">mdi-close</icon-action-button>
                      <icon-action-button v-if="field.new || field.edit" :tooltip="(field.new && 'Guardar') || (field.edit && 'Actualizar')" color="green" @click.native.stop @click="saveField(field)" :disabled="disableField(field) || !user.permissions.Event || !user.permissions.Event.update">mdi-content-save-outline</icon-action-button>
                      <v-icon class="ml-1">{{ isFieldOpen(field) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-list-item>
                    <!-- CONTENIDO colapsable -->
                    <v-expand-transition>
                      <div v-show="isFieldOpen(field)">
                        <v-divider />
                        <div v-if="!field.new && !field.edit" class="d-flex justify-end px-3 pt-2">
                          <icon-action-button
                            tooltip="Editar"
                            color="accent"
                            @click="editField(field)"
                            :disabled="!user.permissions.Event || !user.permissions.Event.update"
                          >mdi-pencil-outline</icon-action-button>
                        </div>
                        <v-row class="pa-3 ma-0" justify="center">
            <v-col cols="12" sm="6" md="4" lg="3">
              <p class="font-weight-bold">Tipo de campo</p>
              <v-radio-group
                :mandatory="false"
                v-model="field.fieldType"
                class="ml-2"
                :disabled="!field.edit && !field.new"
              >
                <v-radio
                  color="primary"
                  label="Campo de texto"
                  value="TEXT"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Opción múltiple"
                  value="LIST"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Archivo (pdf)"
                  value="DOC"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Imagen (jpg, png, jpeg)"
                  value="IMAGE"
                ></v-radio>
                <template v-if="false">
                  <p class="font-weight-medium">Avanzadas</p>
                  <v-radio
                    color="primary"
                    label="Lista de países"
                    value="COUNTRY"
                  ></v-radio>
                </template>
              </v-radio-group>
              <p class="font-weight-bold">Opciones</p>
              <v-switch
                v-model="field.required"
                class="ml-2"
                color="primary"
                label="¿Obligatorio?"
                :disabled="!field.edit && !field.new"
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="4">
              <p class="font-weight-bold">Configuración</p>
              <v-text-field
                label="Nombre del campo o pregunta"
                v-model="field.name"
                filled
                rounded
                :disabled="!field.edit && !field.new"
              ></v-text-field>
              <v-text-field
                label="Descripción"
                v-model="field.description"
                filled
                rounded
                :disabled="!field.edit && !field.new"
              ></v-text-field>
              <v-select
                v-if="formSections.length > 0"
                v-model="field.section"
                :items="[{ _id: null, name: 'Sin sección' }, ...formSections]"
                item-text="name"
                item-value="_id"
                label="Sección"
                filled
                rounded
                clearable
                :disabled="!field.edit && !field.new"
              />
              <v-combobox
                v-model="field.options"
                v-if="field.fieldType === 'LIST' && !field._isDependent"
                hide-selected
                hint="Agrega las opciones de tu campo."
                label="Opciones del campo"
                multiple
                persistent-hint
                small-chips
                filled
                rounded
                :disabled="!field.edit && !field.new"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Presiona
                        <kbd>enter</kbd> para crear una nueva opción.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>

              <!-- Allow multiple answers toggle -->
              <v-switch
                v-if="field.fieldType === 'LIST'"
                v-model="field.allowMultiple"
                class="ml-2 mt-2"
                color="primary"
                label="Permitir seleccionar múltiples respuestas"
                hide-details="auto"
                :disabled="!field.edit && !field.new"
              />

              <!-- Dependent LIST configuration -->
              <v-switch
                v-if="field.fieldType === 'LIST'"
                v-model="field._isDependent"
                class="ml-2 mt-2"
                color="primary"
                label="¿Dependiente de otro campo?"
                hide-details="auto"
                :disabled="!field.edit && !field.new"
                @change="onToggleDependent(field)"
              />
              <template v-if="field.fieldType === 'LIST' && field._isDependent">
                <v-select
                  v-model="field.parentField"
                  :items="listParentCandidates(field)"
                  item-text="name"
                  item-value="_id"
                  label="Campo padre"
                  class="mt-3"
                  filled
                  rounded
                  clearable
                  :disabled="!field.edit && !field.new"
                  @change="onParentFieldChange(field)"
                />
                <template v-if="field.parentField">
                  <p class="font-weight-bold mt-2 mb-1">Opciones por respuesta del campo padre</p>
                  <p class="caption grey--text mb-2">Define las sub-opciones que aparecerán según lo que elija el usuario.</p>
                  <div
                    v-for="parentOpt in getParentFieldOptions(field)"
                    :key="parentOpt"
                  >
                    <v-combobox
                      :value="getConditionalOpts(field, parentOpt)"
                      @input="setConditionalOpts(field, parentOpt, $event)"
                      hide-selected
                      :hint="`Opciones cuando se elige «${parentOpt}»`"
                      :label="parentOpt"
                      multiple
                      persistent-hint
                      small-chips
                      filled
                      rounded
                      class="mb-2"
                      :disabled="!field.edit && !field.new"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Presiona <kbd>enter</kbd> para crear una nueva opción.
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-combobox>
                  </div>
                </template>
              </template>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="4">
              <p class="font-weight-bold">Vista previa</p>
              <v-text-field
                v-if="field.fieldType === 'TEXT'"
                :label="field.name || 'Nombre del campo o pregunta'"
                :hint="field.description || 'Ej. Descripción del campo'"
                persistent-hint
                filled
                rounded
              />
              <template v-if="field.fieldType === 'LIST'">
                <template v-if="field._isDependent && field.parentField">
                  <v-chip small color="blue lighten-4" class="mb-3">
                    <v-icon small left>mdi-link-variant</v-icon>
                    Depende de: {{ getParentField(field) ? getParentField(field).name : 'campo padre' }}
                  </v-chip>
                  <v-select
                    v-model="field._previewParentOpt"
                    :items="getParentFieldOptions(field)"
                    label="Simular selección del campo padre"
                    filled
                    rounded
                    clearable
                    dense
                    class="mb-2"
                    hide-details
                  />
                  <v-select
                    :items="getConditionalOpts(field, field._previewParentOpt)"
                    :label="field.name || 'Nombre del campo'"
                    v-bind:hint="field.description || 'Ej. Descripción del campo'"
                    persistent-hint
                    filled
                    rounded
                    :disabled="!field._previewParentOpt"
                  />
                </template>
                <v-select
                  v-else-if="!field.allowMultiple"
                  :items="field.options"
                  :label="field.name || 'Nombre del campo'"
                  v-bind:hint="field.description || 'Ej. Descripción del campo'"
                  persistent-hint
                  filled
                  rounded
                />
                <v-select
                  v-else
                  :items="field.options"
                  :label="field.name || 'Nombre del campo'"
                  v-bind:hint="field.description || 'Ej. Descripción del campo'"
                  persistent-hint
                  filled
                  rounded
                  multiple
                  small-chips
                />
              </template>
              <v-file-input
                v-if="field.fieldType == 'DOC'"
                truncate-length="35"
                :hint="field.description || 'Ej. Descripción del campo'"
                persistent-hint
                :label="field.name || 'Nombre del campo'"
                filled
                rounded
              ></v-file-input>
              <v-file-input
                v-if="field.fieldType == 'IMAGE'"
                truncate-length="35"
                :hint="field.description || 'Ej. Descripción del campo'"
                :label="field.name || 'Nombre del campo'"
                persistent-hint
                filled
                rounded
              ></v-file-input>
            </v-col>
            <v-col cols="12" class="my-5">
              <v-divider />
            </v-col>
                        </v-row>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </draggable>
        </v-col>
                <h3 v-else class="my-10">No se ha creado ningún campo en esta sección</h3>
              </v-row>

          </v-tab-item>
        </v-tabs-items>
      </template>
      <h3 v-else class="my-10">
        Seleccione un nivel para previsualizar los campos extra
      </h3>
    </v-col>
    <v-dialog v-model="dialogWarning" max-width="800">
      <v-card>
        <v-card-title class="text-h5">
          Ejemplo
        </v-card-title>

        <v-card-text class="subtitle-2">
          En este y en todos los formularios, los campos de "Nombre", "Apellidos", "Email" y "Confirmar e-mail" ya están
          precargados, no es necesario que los otra vez.
          <img src="https://wechamber-v3-files.s3.us-east-2.amazonaws.com/cf5d5199-f581-409e-a3f3-81e800a2f6b0.jpg"
            alt="" srcset="" class="my-2" style="max-width: 100%;">
        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogWarning = false">
            Entendido
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <SectionsTutorialDialog v-model="showTutorial" />
  </v-row>
</template>
<script>
import qs from "query-string";
import Vue from "vue";
import { mapMutations, mapState, mapActions } from "vuex";
import ActionButton from "@/components/shared/ActionButton.vue";
import ModalTemplate from "@/components/shared/ModalTemplate";
import IconActionButton from "@/components/shared/IconActionButton.vue";
import Endpoints from "@/share/Endpoints";
import { formatExtraFields } from "@/utils";
import SectionsTutorialDialog from "@/components/shared/SectionsTutorialDialog.vue";
import draggable from "vuedraggable";

export default {
  components: { ActionButton, ModalTemplate, IconActionButton, SectionsTutorialDialog, draggable },
  props: ["eventId"],
  data: () => ({
    dialogWarning: false,
    showTutorial: false,
    formSections: [],
    savingSectionId: null,
    activeTab: 0,
    openFieldId: null,
    tickets: {
      items: [],
      selected: null,
    },
    extraFields: [],
  }),
  created() {
    if (!localStorage.getItem('sections_tutorial_seen')) {
      this.showTutorial = true;
    }
    this.loading();
    this.getEventTickets();
    this.loaded();
  },
  computed: {
    ...mapState("user", ["user"]),
    tabList() {
      return [{ _id: null, name: 'Sin sección' }, ...this.formSections];
    },
  },
  methods: {
    ...mapMutations("notification", ["show"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapActions("user", ["realoadUserData"]),
    ...mapActions("formSections", [
      "getFormSectionsByTicket",
      "addFormSection",
      "updateFormSection",
      "deleteFormSection",
    ]),
    cancelEdition(field) {
      this.extraFields = this.extraFields.map((auxField) =>
        auxField._id === field._id
          ? { ...field.originalData, edit: false }
          : { ...auxField }
      );
    },

    //campo para imprimir los valores del endpoint
    // actionButonTest(){
    //   console.log(this.tickets)
    //   console.log(this.extraFields)
    // },
    cancelAction(field) {
      if (this.openFieldId === field._id) this.openFieldId = null;
      field?.edit && this.cancelEdition(field);
      field?.new && this.removeField(field._id);
    },
    toggleField(field) {
      this.openFieldId = this.openFieldId === field._id ? null : field._id;
    },
    isFieldOpen(field) {
      return this.openFieldId === field._id || !!field.new || !!field.edit;
    },
    fieldTypeLabel(type) {
      const map = { TEXT: 'Texto', LIST: 'Opción múltiple', DOC: 'Documento', DATE: 'Fecha', NUMBER: 'Número', IMAGE: 'Imagen' };
      return map[type] || type;
    },
    persistFieldOrder(field) {
      if (!field._id || field.new) return;
      this.axios.put(
        Endpoints.extraFieldsModifyField.replace(':fieldId', field._id),
        { registrationField: { order: field.order } }
      ).catch(() => {});
    },
    onFieldDragEnd({ oldIndex, newIndex }, tabId) {
      if (oldIndex === newIndex) return;
      const tabFields = this.fieldsForTab(tabId).slice();
      const [moved] = tabFields.splice(oldIndex, 1);
      tabFields.splice(newIndex, 0, moved);
      tabFields.forEach((f, i) => { f.order = i + 1; });
      const others = this.extraFields.filter(f => {
        const sid = (f.section && (f.section._id || f.section)) || null;
        return sid !== (tabId || null);
      });
      this.extraFields = [...others, ...tabFields];
      tabFields.filter(f => !f.new).forEach(f => this.persistFieldOrder(f));
    },
    formatTicketsData: ({ _id, name }) => ({ id: _id, name }),
    async getEventTickets() {
      const endpoint = qs.stringifyUrl({
        url: Endpoints.ticketsByEvent.replace(":eventId", this.eventId),
        query: {
          page: 1,
          limit: 100,
        },
      });
      const response = await this.axios.get(endpoint);
      if (response.status === 200) {
        const { tickets } = response.data;
        tickets.length > 0 &&
          (this.tickets.items = tickets.map(this.formatTicketsData));
      }
    },
    async handleTicketSelection(ticketId) {
      this.activeTab = 0;
      const response = await this.axios.get(
        Endpoints.extraFieldsTicket.replace(":ticketId", ticketId)
      );
      if (response.status === 200) {
        const sectionsRes = await this.getFormSectionsByTicket(ticketId);
        if (sectionsRes.status) {
          this.formSections = sectionsRes.data.sections || [];
        }
        let fields = response.data.registrationFields;

        const fieldsWithOrder = fields.filter((field) => field.order != null);
        const fieldsWithoutOrder = fields.filter(
          (field) => field.order == null
        );

        fieldsWithOrder.sort((a, b) => a.order - b.order);

        let orderedFields = [...fieldsWithoutOrder];
        for (const field of fieldsWithOrder) {
          const position = field.order - 1;
          orderedFields.splice(position, 0, field);
        }

        this.extraFields = orderedFields.map((field) => ({
          ...field,
          _isDependent: !!(field.parentField),
          allowMultiple: field.allowMultiple || false,
          edit: false,
        }));
      }
    },
    addField() {
      const activeSection = this.tabList[this.activeTab];
      const field = {
        _id: new Date().getTime(),
        ticket: this.tickets.selected,
        event: this.eventId,
        fieldType: "TEXT",
        required: false,
        name: "",
        formattedName: "",
        description: "",
        options: [],
        parentField: null,
        conditionalOptions: null,
        allowMultiple: false,
        _isDependent: false,
        section: activeSection?._id || null,
        new: true,
      };
      this.extraFields.push({ ...field, deleteDialog: false });
      this.openFieldId = field._id;
      this.$nextTick(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      });
    },
    async createField(field) {
      try {
        this.loading();
        delete field.new;
        const { _id: temporaryId, ...restFieldProps } = field;
        const formattedName = formatExtraFields(field.name);
        const payload = {
          registrationField: { ...restFieldProps, formattedName },
        };
        const response = await this.axios.post(
          Endpoints.extraFieldsAddField,
          payload
        );
        if (response.status === 200) {
          const { registrationField } = response.data;
          this.extraFields = this.extraFields.map((ticket) =>
            ticket._id === temporaryId
              ? {
                  ...restFieldProps,
                  ...registrationField,
                  edit: false,
                  id: registrationField._id,
                }
              : ticket
          );
          this.show({
            color: "primary",
            text: "Campo extra creado",
          });
        }
      } catch (error) {
        console.log({ error });
      } finally {
        this.loaded();
      }
    },
    async updateField(field) {
      this.loading();
      try {
        const {
          name,
          description,
          required,
          event,
          status,
          fieldType,
          options,
          allowMultiple,
          ticket,
          _id,
          order,
          parentField,
          conditionalOptions,
          section
        } = field;
        const registrationField = {
          name,
          event,
          status,
          formattedName: formatExtraFields(name),
          description,
          required,
          fieldType,
          options,
          allowMultiple: allowMultiple || false,
          ticket,
          order,
          parentField: parentField || null,
          conditionalOptions: conditionalOptions || null,
          section: section || null
        };
        const res = await this.axios.put(
          Endpoints.extraFieldsModifyField.replace(":fieldId", _id),
          { registrationField }
        );
        if (res.status === 200) {
          this.extraFields = this.extraFields.map((auxField) =>
            auxField._id === _id
              ? { ...auxField, ...registrationField, edit: false }
              : { ...auxField }
          );
          this.show({
            color: "primary",
            text: "Campo extra actualizado",
          });
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loaded();
      }
    },
    saveField(field) {
      field?.edit && this.updateField(field);
      field?.new && this.createField(field);
    },
    editField(field) {
      field.edit = true;
      field.originalData = { ...field };
      this.openFieldId = field._id;
    },
    async deleteField(field) {
      const { _id: fieldId, new: newField } = field;
      if (!newField) {
        await this.axios.delete(
          Endpoints.extraFieldsModifyField.replace(":fieldId", fieldId)
        );
        this.show({
          color: "primary",
          text: "Campo eliminado correctamente",
        });
      }
      this.removeField(fieldId);
      field.deleteDialog = false;
    },
    removeField(fieldId) {
      this.extraFields = this.extraFields.filter(
        (field) => field._id !== fieldId
      );
    },
    disableField(field) {
      const { originalData, ...rest } = field;
      const isFormWithoutChanges =
        JSON.stringify(originalData) === JSON.stringify(rest);
      return isFormWithoutChanges;
    },
    onToggleDependent(field) {
      if (!field._isDependent) {
        field.parentField = null;
        field.conditionalOptions = null;
      }
    },
    listParentCandidates(field) {
      return this.extraFields.filter(
        (f) => f.fieldType === 'LIST' && f._id !== field._id
      );
    },
    getParentField(field) {
      if (!field.parentField) return null;
      return this.extraFields.find((f) => f._id == field.parentField) || null;
    },
    getParentFieldOptions(field) {
      const parent = this.getParentField(field);
      if (!parent) return [];
      if (parent._isDependent && parent.conditionalOptions) {
        const allOpts = new Set();
        const co =
          parent.conditionalOptions instanceof Map
            ? Object.fromEntries(parent.conditionalOptions)
            : parent.conditionalOptions;
        Object.values(co).forEach((opts) => opts.forEach((o) => allOpts.add(o)));
        return [...allOpts];
      }
      return parent.options || [];
    },
    getConditionalOpts(field, optKey) {
      if (!field.conditionalOptions || !optKey) return [];
      const co =
        field.conditionalOptions instanceof Map
          ? Object.fromEntries(field.conditionalOptions)
          : field.conditionalOptions;
      return co[optKey] || [];
    },
    setConditionalOpts(field, optKey, values) {
      if (!field.conditionalOptions) {
        Vue.set(field, 'conditionalOptions', {});
      }
      Vue.set(field.conditionalOptions, optKey, values);
    },
    onParentFieldChange(field) {
      field.conditionalOptions = null;
    },
    async addSection() {
      const nextOrder = this.formSections.length + 1;
      const res = await this.addFormSection({
        name: 'Nueva sección',
        order: nextOrder,
        ticket: this.tickets.selected,
        event: this.eventId
      });
      if (res.status) {
        this.formSections.push({ ...res.data.section, _editing: true });
        this.$nextTick(() => {
          this.activeTab = this.formSections.length; // tabList = [Sin sección, ...sections]
        });
      }
    },
    async saveSectionName(section) {
      this.savingSectionId = section._id;
      await this.updateFormSection({ id: section._id, payload: { name: section.name, order: section.order } });
      Vue.set(section, '_editing', false);
      this.savingSectionId = null;
    },
    async removeSectionAdmin(section) {
      const res = await this.deleteFormSection(section._id);
      if (res.status) {
        this.activeTab = 0;
        this.formSections = this.formSections.filter(s => s._id !== section._id);
        this.extraFields = this.extraFields.map(f =>
          (f.section === section._id || (f.section && f.section._id === section._id))
            ? { ...f, section: null }
            : f
        );
        this.show({ color: 'primary', text: 'Sección eliminada' });
      }
    },
    fieldsForTab(sectionId) {
      if (!sectionId) {
        const sectionIds = new Set(this.formSections.map(s => s._id));
        return this.extraFields.filter(f => {
          const sid = f.section && (f.section._id || f.section);
          return !sid || !sectionIds.has(sid);
        });
      }
      return this.extraFields.filter(f => {
        if (!f.section) return false;
        const sid = f.section._id || f.section;
        return sid === sectionId;
      });
    },
  },
};
</script>

<style scoped>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
.drag-ghost {
  opacity: 0.45;
  background: #f5f5f5;
  border: 2px dashed #9e9e9e !important;
  border-radius: 8px;
}
</style>